import { CirclePlay, Forward, Heart, MessageSquareText, Percent } from 'lucide-react';

import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';
import { formatNumber } from '@/shared/utils/format-number';

interface PostStatsProps {
  views: number;
  likes: number;
  comments: number;
  shares: number;
  engagementRate: number;
  hideShares?: boolean;
}

export function PostStats({
  views,
  likes,
  comments,
  shares,
  engagementRate,
  hideShares,
}: PostStatsProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex items-center gap-1">
        <CirclePlay className="text-muted-foreground size-4" />
        <span className="text-muted-foreground text-sm font-normal">{formatNumber(views)}</span>
      </div>
      <div className="flex items-center gap-1">
        <Heart className="text-muted-foreground size-4" />
        <span className="text-muted-foreground text-sm font-normal">{formatNumber(likes)}</span>
      </div>
      <div className="flex items-center gap-1">
        <MessageSquareText className="text-muted-foreground size-4" />
        <span className="text-muted-foreground text-sm font-normal">{formatNumber(comments)}</span>
      </div>
      {!hideShares && (
        <div className="flex items-center gap-1">
          <Forward className="text-muted-foreground size-4" />
          <span className="text-muted-foreground text-sm font-normal">{formatNumber(shares)}</span>
        </div>
      )}
      <TooltipFlat
        asChild
        contentClassName="w-96"
        content={
          <>
            <span className="font-bold">Engagement Rate</span>
            <br />
            [(likes + comments + shares)/ views]
            <br />
            <br />
            <span className="font-bold">Example:</span>
            <br />
            [(100 + 50 + 25)/ 1000] = 0.175 (17.5%)
          </>
        }
      >
        <div className="flex items-center gap-1">
          <Percent className="text-muted-foreground size-4" />
          <span className="text-muted-foreground text-sm font-normal">{engagementRate}%</span>
        </div>
      </TooltipFlat>
    </div>
  );
}
